module.exports = __webpack_public_path__ + "img/result_txt_hd.3bd27123.png";